<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text"> Indicação Cirurgica</v-col>

      <v-col cols="auto">
        <v-btn color="light-blue" dark @click="saveSurgeryIndicationAndExit">
          salvar
        </v-btn>
      </v-col>

      <v-col cols="auto">
        <v-btn
          color="gray lighten-1"
          dark
          :to="`/prontuario/${this.attendance.id}/indicacao-cirurgica`"
        >
          voltar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-row dense>
          <v-col>
            <v-combobox
              label="Requisitado por"
              v-model="requester"
              outlined
              dense
              :hide-details="!errors.requester"
              :error-messages="errors.requester"
              background-color="white"
              :items="doctorUsers"
              item-text="employee.name"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              label="Encaminhado para"
              v-model="forwardTo"
              outlined
              dense
              :hide-details="!errors.forwardTo"
              :error-messages="errors.forwardTo"
              background-color="white"
              :items="doctorUsers"
              item-text="employee.name"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>


        <v-row dense>
          <v-col>
            <v-combobox
              label="Cirugia"
              v-model="surgeryType"
              outlined
              dense
              :hide-details="!errors.surgeryType"
              :error-messages="errors.surgeryType"
              background-color="white"
              :items="orderedSurgeryTypes"
              item-text="name"
              @change="changeSurgeryType"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              label="Técnica"
              v-model="surgeryTypeTechnique"
              hide-details
              outlined
              dense
              background-color="white"
              :items="surgeryTypeTechniques"
              item-text="name"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              label="Local"
              v-model="site"
              outlined
              dense
              :hide-details="!errors.site"
              :error-messages="errors.site"
              background-color="white"
              :items="sites"
              :disabled="attendanceEsigned"
              @change="changeSite"
            />
          </v-col>
        </v-row>

        <!-- <v-row dense> -->
        <!--   <v-col> -->
        <!--     <v-text-field -->
        <!--       label="Quantidade" -->
        <!--       v-model="requestedQuantity" -->
        <!--       dense -->
        <!--       :hide-details="!errors.requestedQuantity" -->
        <!--       :error-messages="errors.requestedQuantity" -->
        <!--       outlined -->
        <!--       type="number" -->
        <!--       min="1" -->
        <!--       background-color="white" -->
        <!--     /> -->
        <!--   </v-col> -->
        <!-- </v-row> -->

        <v-row dense>
          <v-col>
            <v-combobox
              label="Anestesia"
              v-model="anesthesia"
              hide-details
              outlined
              dense
              background-color="white"
              :items="anesthesias"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              label="Materiais"
              v-model="materials"
              hide-details
              outlined
              dense
              background-color="white"
              multiple
              chips
              small-chips
              deletable-chips
              :items="orderedMaterials"
              item-text="name"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-textarea
              v-model="observation"
              v-uppercase
              label="Notas"
              hide-details
              outlined
              dense
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-textarea
          :value="surgeryIndicationText"
          rows="17"
          readonly
          hide-details
          outlined
          dense
          background-color="white"
          :disabled="attendanceEsigned"
        />
      </v-col>
    </v-row>

    <v-expansion-panels>
      <v-expansion-panel @click="saveSurgeryIndication">
        <v-expansion-panel-header class="text-h5 gray--text">
          Próteses
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="surgeryIndication">
          <ProsthesisList
            :refreshProstheses="refreshProstheses"
            :surgeryIndication="surgeryIndication"
            :surgeryIndicationProstheses="surgeryIndication.prostheses"
            :allowDelete="!attendanceEsigned"
            :allowEdit="!attendanceEsigned"
            :showForm="!attendanceEsigned"
            @update-surgery-indication-prostheses="updateProstheses"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";

export default {
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    ProsthesisList,
  },
  data() {
    return {
      anesthesia: "",
      anesthesias: [
        "Bloqueio peribulbar",
        "Geral inalatória",
        "Geral",
        "Intracameral",
        "Local",
        "local com sedacao",
        "Sedação",
        "Tópica",
      ],
      emergency: false,
      errors: {},
      medicalRequestItems: [],
      selectedsItems: [],
      itemsFilter: "",
      medicalRequestType: "",
      surgeryIndicationId: null,
      surgeryType: null,
      surgeryTypeTechnique: null,
      materials: [],
      observation: "",
      observations: "",
      reason: "",
      requester: "",
      diagnosticHypothesis: "",
      forwardTo: "",
      requestedQuantity: "",
      site: "",
      sites: [
        "Olho direito",
        "Olho esquerdo",
        "Ambos os olhos",
        "Pálpebra direta",
        "Pálpebra esquerda",
        "Ambas pálpebras",
      ],
    };
  },
  created() {
    if (this.$route.params.surgery_indication_id) {
      if (this.$route.params.surgery_indication_id !== "nova") {
        this.surgeryIndicationId = this.$route.params.surgery_indication_id;
        this.refreshProstheses();
      }
    }
  },
  apollo: {
    diagnosticHypotheses: {
      query: require("@/graphql/diagnostic_hypotheses.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    surgeryTypes: {
      query: require("@/graphql/surgery_type/surgery_types.gql"),
    },
    surgeryIndicationMaterials: {
      query: require("@/graphql/surgery_indication/materials.gql"),
    },
    users: {
      query: require("@/graphql/users.gql"),
      result() {
        if (this.$store?.state?.authentication?.user?.id) {
          let userId = this.$store.state.authentication.user.id;

          this.forwardTo = this.lodash.find(this.doctorUsers, {
            id: userId,
          });

          this.requester = this.lodash.find(this.doctorUsers, {
            id: userId,
          });
        }
      },
    },
    surgeryIndication: {
      query: require("@/graphql/surgery_indication/surgery_indication.gql"),
      variables() {
        return {
          surgeryIndicationId: this.surgeryIndicationId,
        };
      },
      skip() {
        return !this.surgeryIndicationId;
      },
      result({ data }) {

        if (data.surgeryIndication?.performer?.id) {
        this.forwardTo =  this.lodash.find(this.doctorUsers, {
              id: data.surgeryIndication.performer.id,
            });
            }

        if (data.surgeryIndication?.requester?.id) {
        this.requester =  this.lodash.find(this.doctorUsers, {
              id: data.surgeryIndication.requester.id,
            });
            }


        if (data?.surgeryIndication) {

          if (data?.surgeryIndication?.surgeryType?.id) {
            this.surgeryType = this.lodash.find(this.surgeryTypes, {
              id: data.surgeryIndication.surgeryType.id,
            });
          }
        }
        if (data.surgeryIndication?.surgeryTypeTechnique?.id) {
          this.surgeryTypeTechnique = this.lodash.find(
            this.surgeryTypeTechniques,
            {
              id: data.surgeryIndication.surgeryTypeTechnique.id,
            }
          );
        }
        this.materials = this.lodash.filter(
          this.surgeryIndicationMaterials,
          function(e) {
            return this.lodash
              .map(data.surgeryIndication.materials, "id")
              .includes(e.id);
          }.bind(this)
        );
        this.observation = data.surgeryIndication.observation;
        this.anesthesia = data.surgeryIndication.anesthesia;
        this.site = data.surgeryIndication.site;
      },
    },
  },
  computed: {
    allDiagnosticHypotheses() {
      return this.lodash.filter(this.diagnosticHypotheses, {
        currentStatus: "active",
      });
    },
    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "doctor" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    surgeryTypeTechniques() {
      if (this.surgeryType) {
        return this.lodash.orderBy(
          this.lodash.filter(this.surgeryType.techniques, ["deletedAt", null]),
          [
            (e) =>
              e.name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""),
          ],
          ["asc"]
        );
      }

      return [];
    },
    orderedSurgeryTypes() {
      return this.lodash.orderBy(
        this.lodash.filter(this.surgeryTypes, ["deletedAt", null]),
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    surgeryIndicationText() {
      let text = "";

      if (this.surgeryType) {
        text += `Recomendado Cirurgia ${this.surgeryType.name}`;
      }

      if (this.surgeryTypeTechnique) {
        text += ` utilizando a técnica ${this.surgeryTypeTechnique.name},`;
      }

      if (this.site) {
        text += ` no ${this.site}`;
      }

      if (this.anesthesia) {
        text += ` Anestesia do tipo ${this.anesthesia}`;
      }

      if (!this.lodash.isEmpty(this.materials)) {
        text += ` utilizando: \n`;
        this.materials.forEach((material) => {
          text += `${material.name}\n`;
        });
      }

      if (this.observation) {
        text += `\n${this.observation}`;
      }

      return text;
    },
    orderedMaterials() {
      return this.lodash.orderBy(
        this.lodash.filter(this.surgeryIndicationMaterials, [
          "deletedAt",
          null,
        ]),
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["name"],
        ["asc"]
      );
    },
  },
  methods: {
    updateProstheses(prostheses) {
      this.surgeryIndication.prostheses = prostheses;
    },
    changeSurgeryType() {
      this.surgeryTypeTechnique = null;
    },
    changeSite() {
      if (this.site === "Ambos os olhos" || this.site === "Ambas pálpebras") {
        this.requestedQuantity = 2;
      } else {
        this.requestedQuantity = 1;
      }
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido";
      //const errorBillableMsg = "Necessário colocar CID com subclassificação";
      this.errors = {};

      if (!this.surgeryType?.id) {
        this.errors.surgeryType = errorMsg;
      }
      if (this.lodash.isEmpty(this.site.trim())) {
        this.errors.site = errorMsg;
      }
      if (this.lodash.isEmpty(this.site.trim())) {
        this.errors.site = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    saveSurgeryIndicationAndExit() {
      if (this.saveSurgeryIndication()) {
        this.$router.push(
          `/prontuario/${this.attendance.id}/indicacao-cirurgica`
        );
      }
    },
    saveSurgeryIndication() {
      if (this.attendanceEsigned) return false;
      if (!this.validate()) return false;
      this.$store.dispatch("updateLoading", true);
      this.apolloMutate({
        mutation: require("@/graphql/surgery_indication/save_surgery_indication.gql"),
        variables: {
          attendanceId: this.attendance.id,
          surgeryIndicationId: this.surgeryIndicationId,
          surgeryTypeId: this.lodash.get(this.surgeryType, "id", ""),
          requesterId: this.lodash.get(this.requester, "id", ""),
          performerId:this.lodash.get(this.forwardTo, "id", ""),
          surgeryTypeTechniqueId: this.lodash.get(
            this.surgeryTypeTechnique,
            "id",
            ""
          ),
          materialIds: this.materials.map((material) => material.id),
          anesthesia: this.anesthesia,
          site: this.site,
          observation: this.observation,
        },
      }).then(({ data }) => {
        this.refreshProstheses();
        this.surgeryIndicationId = data.saveSurgeryIndication.id;
        this.$store.dispatch("createNotification", {
          message: "Indicação cirúrgica criada com sucesso. Aguarde um momento para que ela seja exibida no seu painel.",
          type: "success",
        });
      });
      return true;
    },
    refreshProstheses() {
      this.$apollo.queries.surgeryIndication.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
